import { InjectionToken } from '@angular/core';

export interface SvgIconDefinition {
  name: string;
  content: string;
}

export const SVG_ICONS = new InjectionToken<SvgIconDefinition | SvgIconDefinition[]>('SVG_ICONS');
